export const DEFAULT_TIMEZONE = "Europe/Moscow";
export const DEFAULT_LOCALE = "ru-RU";
export const DAY = 1000 * 60 * 60 * 24;
